/**
 * Ricos throws `Received empty palette colors array` when handed an empty palette, and
 * hosts outside OOI may have no site colors at all. Omitting the key entirely lets Ricos
 * fall back to its own theme.
 *
 * Returned as `object` on purpose: `palette` is deprecated in the `/next` RicosTheme
 * types but still honoured at runtime, so a precise type would need a ts-expect-error at
 * every call site.
 */
export const resolveRicosPalette = (siteColors) => siteColors?.length ? { palette: siteColors } : {};
//# sourceMappingURL=resolve-ricos-palette.js.map